/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useCallback, useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { BsFillPencilFill, BsPersonBadgeFill, BsServer } from 'react-icons/bs';
import { MdPermDeviceInformation } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import OrgEdit from './OrgEdit';
import Loader from '../../../../../../components/ui-elements/loader';
import { useNavigate } from 'react-router-dom';
import { FaHistory } from 'react-icons/fa';
import OrgHistory from './OrgHistory';
import { getAllOrg } from '../../../../../../store/reducers/organization/organizationAction';

const OrgsList = () => {
    const [selectedOrg, setSelectedOrg] = useState({});
    const [openEditOrg, setOpenEditOrg] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openHistoryOrg, setOpenHistoryOrg] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const organizations = useSelector(state => state.organization.organizations)
    const handleCloseDialog = () => {
        setOpenEditOrg(false);
        setOpenHistoryOrg(false);
    }
    const fetchOrgs = useCallback(async () => {
        try {
            setLoading(true);
            await dispatch(getAllOrg()).unwrap();
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }, [dispatch]);
    useEffect(() => {
        fetchOrgs()
    }, [fetchOrgs])
    return (
        <>
            {!loading ? <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell label="Organization Name" />
                            <StyledTableCell label="Details" />
                            <StyledTableCell label=" " />

                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {organizations?.Records?.length > 0 && organizations.Records.map((row) => (
                            <StyledTableRow key={row.username}>
                                <StyledTableCell label={row.organizationName} />
                                <StyledTableCell   >
                                    {row.organizationDetails.length > 0 ?
                                        <Typography style={{ fontWeight: 'bold' }} color={row.organizationDetails[0].detailValue === "true" ? 'primary' : 'error'}>
                                            {row.organizationDetails[0].detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                                        </Typography> : "N/A"}
                                </StyledTableCell>

                                <StyledTableCell align="right"  >
                                    <Tooltip title={row.organizationName + " Edit"} placement="right" arrow>

                                        <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedOrg(row); setOpenEditOrg(true) }}>
                                            <BsFillPencilFill />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={row.organizationName + " Applications Details"} placement="right" arrow>

                                        <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { navigate('/manage-organizations/applications/' + row.organizationID) }}>
                                            <MdPermDeviceInformation />
                                        </IconButton>

                                    </Tooltip>
                                    <Tooltip title={row.organizationName + " Organization Users"} placement="right" arrow>

                                        <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { navigate('/manage-organizations/users/' + row.organizationID) }}>
                                            <BsPersonBadgeFill />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={row.organizationName + " Identity Providers"} placement="right" arrow>

                                        <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { navigate('/manage-organizations/identity-providers/' + row.organizationID) }}>
                                            <BsServer />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title={row.organizationName + "  History"} placement="right" arrow>

                                        <IconButton color='primary' onClick={() => { setSelectedOrg(row); setOpenHistoryOrg(true) }}>
                                            <FaHistory />
                                        </IconButton>
                                    </Tooltip>

                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer> : (<Loader />)}


            <DialogContainer
                open={openEditOrg}
                handleClose={handleCloseDialog}
            >
                <OrgEdit
                    selectedOrg={selectedOrg}
                    handleClose={handleCloseDialog} />
            </DialogContainer>

            <DialogContainer
                open={openHistoryOrg}
                handleClose={handleCloseDialog}
            >
                <OrgHistory
                    selectedOrg={selectedOrg}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}


export default OrgsList;